<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Partnering'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">Innovative Partnerships Built to Last</div>
				<div class="txt">Share the passion and vision—collaborate with CorDx.</div>
			</div>
			<!--块1-->
			<!--banner-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/img01@2x.webp" />
			</div>
			<!--banner-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_2_main">
					<div class="left">
						<div class="img_box">
							<img src="../../assets/img/图像 11@2x.webp" />
						</div>
						<div class="msg_box">
							<div class="tit">What We Look For</div>
							<div class="txt">
								CorDx partners with organizations around the world to develop, manufacture, and supply diagnostics that empower users to monitor and improve their health. We prioritize partnerships that create benefits and make a difference for caregivers and patients alike. Our partners share our passion and vision for scientific innovation with collaboration, insight, and effectiveness.
							</div>
						</div>
					</div>
					<div class="right">
						<div class="img_box">
							<img src="../../assets/img/蒙版组 3@2x.webp" />
						</div>
						<div class="msg_box">
							<div class="tit">Built to Last</div>
							<div class="txt">
								We invest in partnerships that are built to last. Each relationship is carefully built on trust, transparency, and a shared goal of innovation and client benefit. From our first interaction, we strive to ensure that both parties’ needs are met. At each stage, we collaboratively evaluate our actions and modify our approach as necessary to meet our mutual goals.
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_main">
					<div class="title"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>Our Partners</div>
					<div class="block_5_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="block_5_el" @click="goWeb('https://www.hsa.gov.sg/')">
							<img src="../../assets/img_public/Partner_07.png" style="width: 160px;" />
						</div>
						<div class="block_5_el" @click="goWeb('https://www.gatech.edu/')">
							<img src="../../assets/img_public/Partner_02.png" style="width: 240px;" />
						</div>
						<div class="block_5_el" @click="goWeb('https://tyfast.energy/')">
							<img src="../../assets/img_public/Partner_03.png" style="width: 210px;" />
						</div>
						<div class="block_5_el" @click="goWeb('https://ucsd.edu/')">
							<img src="../../assets/img_public/Partner_04.png" style="width: 220px;" />
						</div>
						<div class="block_5_el" @click="goSSB">
							<img src="../../assets/img_public/Partner_08.webp" style="width: 270px;" />
						</div>
						<div class="block_5_el" @click="goWeb('https://www.nih.gov/')">
							<img src="../../assets/img_public/Partner_06.png" style="width: 145px;" />
						</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--块8-->
			<div class="block_8"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_8_main" @click="goPDF">
					<img class="bg" src="../../assets/img/bg_tf.webp" />
					<div class="msg_box">
						<div class="left">
							<img src="../../assets/img/icon_warning.webp" />
						</div>
						<div class="right">
							ANTI-BRIBERY<br />
							& ANTI-CORRUPTION POLICY
						</div>
					</div>
				</div>
			</div>
			<!--块8-->
			<!--块6-->
			<div class="block_6"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="msg_box">
					<div class="tit">Propose a Partnership</div>
					<div class="txt">Join us and change the world of diagnostics</div>
					<div class="btn_box_more btn_box" @click="goContact">
						Contact Us<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
				<div class="img_box">
					<img src="../../assets/img/背景图@2x.webp" />
				</div>
			</div>
			<!--块6-->
			<!--块7-->
			<div class="block_7"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_7_main">
					<div class="title">Recent News</div>
					<div class="block_7_box">
						<div
							v-for="(value, index) in newsData"
							:key="index"
							class="block_7_el"
							@mouseover="newsOver(value.id)"
							@mouseleave="newsLeave"
							@click="goResourcesInfo(value)"
						>
							<img :src="value.image" />
							<div class="msg_box">
								<div class="txt">{{ value.title }}</div>
							</div>
							<div class="time">{{ value.fabu_time }}</div>
							<div v-if="isShow == value.id" class="mask_box"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="mask_tit">{{ value.title }}</div>
								<div class="mask_txt">{{ value.description }}</div>
							</div>
						</div>
					</div>
					<div class="btn_box_more" style="position: absolute;left: 50%;transform: translate(-50%, 0px);" @click="goResources">
						View More<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块7-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { resourcesList } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isShow: null,
			newsData: [],  //新闻数据
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Partnering - CorDx';
		resourcesList({
			catid: 1,
			page: 1,
			page_size: 3,
			language: sessionStorage.getItem('lang'),
		}).then(res2 => {
			that.newsData = res2.data.data;
		});
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			// let { href } = that.$router.resolve({
			// 	path: '/resources-info',
			// 	query: {
			// 		id: value.unionid,
			// 	}
			// });
			// window.open(href, '_blank');
			let routeData = that.$router.resolve({name: "Resourcesinfo", params: { resourcesInfoId: value.custom } });
			window.open(routeData.href, '_blank');
		},
		//新闻滑入
		newsOver(value) {
			let that = this;
			that.isShow = value;
		},
		//新闻滑出
		newsLeave() {
			let that = this;
			that.isShow = null;
		},
		goContact() {
			this.$router.push({ path: '/contact', });
		},
		goResources() {
			this.$router.push({ path: '/resources', });
		},
		//跳转外站
		goWeb(value) {
			let that = this;
			window.open(value, '_blank');
		},
		//跳转反贿赂&贪腐
		goPDF() {
			let that = this;
			let routeData = that.$router.resolve({ path: "/ANTI-BRIBERY-AND-ANTI-CORRUPTION-POLICY" });
			window.open(routeData.href, '_blank');
		},
		goSSB() {
			this.$router.push({ path: '/scientific-strategy-board', });
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	//块8
	.block_8{
		width: 100%;
		padding: 90px 0 0px 0;
		.block_8_main{
			width: 1140px;
			margin: 0 auto;
			position: relative;
			cursor: pointer;
			.msg_box{
				position: absolute;
				top: 50%;
				left: 74px;
				transform: translate(0, -50%);
				display: flex;
				align-items: center;
				.right{
					flex: 1;
					font-size: 36px;
					padding-left: 40px;
				}
				.left{
					width: 64px;
					img{
						width: 100%;
					}
				}
			}
			.bg{
				width: 100%;
			}
		}
	}
	/*块5*/
	.block_5{
		width: 100%;
		padding: 180px 0 0 0;
		//background-color: #F2F7FD;
		.block_5_main{
			width: 1140px;
			margin: 0 auto;
			.block_5_box{
				padding-top: 0px;
				.block_5_el{
					width: 31%;
					height: 200px;
					display: inline-block;
					margin: 10px;
					background-color: #ffffff;
					box-shadow: 0 0 8px rgb(230, 230, 230, 0.2);
					border-radius: 5px;
					cursor: pointer;
					position: relative;
					img{
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}
			.text{
				padding-top: 20px;
				color: #000000;
				font-size: 18px;
			}
			.title{
				padding-bottom: 10px;
				margin-bottom: 40px;
				font-size: 45px;
				color: #000000;
				border-bottom: 1px solid #333333;
			}
		}
	}
	/*块2*/
	.block_2{
		width: 100%;
		background-color: transparent;
		background-image: linear-gradient(180deg, #FFFFFF 20%, #F1ECE6 100%);
		.block_2_main{
			width: 1140px;
			margin: 0 auto;
			display: flex;
			background-color: #FFFFFF;
			box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
			position: relative;
			top: 95px;
			.left, .right{
				flex: 1;
				position: relative;
				padding: 0 0 55px 0;
				.msg_box{
					padding: 30px 38px 20px 38px;
					.tit{
						font-size: 34px;
					}
					.txt{
						padding-top: 20px;
						font-size: 20px;
					}
				}
				.img_box{
					img{ width: 100%; }
				}
			}
		}
	}
	/*块7*/
	.block_7{
		width: 100%;
		background-color: transparent;
		background-image: linear-gradient(180deg,  #F1ECE6 20%, #FFFFFF 100%);
		.block_7_main{
			width: 1140px;
			margin: 0 auto;
			padding: 100px 0 150px 0;
			.block_7_box{
				display: flex;
				padding: 60px 0 50px 0;
				.block_7_el{
					flex: 1;
					position: relative;
					margin: 0 20px;
					background-color: #ffffff;
					box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
					cursor: pointer;
					overflow: hidden;
					.mask_box{
						position: absolute;
						width: 100%;
						height: 100%;
						top: 0;
						background-color: #ffffff;
						padding: 34px;
						.mask_tit{
							font-size: 20px;
							color: #000000;
						}
						.mask_txt{
							padding-top: 40px;
							font-size: 16px;
							color: #706B69;
						}
					}
					.msg_box{
						width: 100%;
						padding: 30px 34px 120px 34px;
						border-top: 2px solid #0B318F;
						.txt{
							color: #000000;
							font-size: 22px;
						}
					}
					.time{
						position: absolute;
						z-index: 2;
						bottom: 40px;
						left: 34px;
						font-size: 18px;
						color: #706B69;
					}
					img{
						width: 100%;
						// height: auto;
						height: 227px;
						object-fit: cover;
					}
				}
			}
			.title{
				font-size: 45px;
				color: #000000;
			}
		}
	}
	/*块6*/
	.block_6{
		width: 100%;
		padding-top: 0px;
		.msg_box{
			width: 1140px;
			margin: 0 auto;
			padding: 90px 0 50px 0;
			text-align: center;
			.btn_box{
				margin-top: 40px;
			}
			.txt{
				font-size: 30px;
				color: #000000;
			}
			.tit{
				font-size: 65px;
				color: #000000;
			}
		}
		.img_box{
			img{ width: 100%; }
		}
	}
	/*banner*/
	.banner_box{
		img{
			width: 100%;
		}
	}
	/*块1*/
	.block_1{
		width: 1140px;
		margin: 0 auto;
		padding: 50px 50px 0 50px;
		color: #000000;
		text-align: center;
		.tit{
			font-size: 60px;
		}
		.txt{
			font-size: 30px;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: #FFFFFF;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
